/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InboundPictureOrderInfoVo
 */
export interface InboundPictureOrderInfoVo {
    /**
     * 订单id
     * @type {number}
     * @memberof InboundPictureOrderInfoVo
     */
    orderId?: number;
    /**
     * 订单号
     * @type {string}
     * @memberof InboundPictureOrderInfoVo
     */
    orderCode?: string;
    /**
     * 区域
     * @type {string}
     * @memberof InboundPictureOrderInfoVo
     */
    zone?: string;
    /**
     * 库位
     * @type {string}
     * @memberof InboundPictureOrderInfoVo
     */
    location?: string;
    /**
     * 附加服务
     * @type {string}
     * @memberof InboundPictureOrderInfoVo
     */
    additionalService?: string;
    /**
     * 备注
     * @type {string}
     * @memberof InboundPictureOrderInfoVo
     */
    remark?: string;
    /**
     * 仓库备注
     * @type {string}
     * @memberof InboundPictureOrderInfoVo
     */
    warehouseRemarkCn?: string;
    /**
     * 仓库备注
     * @type {string}
     * @memberof InboundPictureOrderInfoVo
     */
    warehouseRemarkKr?: string;
    /**
     * 所有快递单号
     * @type {string}
     * @memberof InboundPictureOrderInfoVo
     */
    allParcelTrackingNumber?: string;
    /**
     * 接收人配送要求
     * @type {string}
     * @memberof InboundPictureOrderInfoVo
     */
    receiverDeliveryRequirement?: string;
    /**
     * 唛头号
     * @type {string}
     * @memberof InboundPictureOrderInfoVo
     */
    markNos?: string;
}

/**
 * Check if a given object implements the InboundPictureOrderInfoVo interface.
 */
export function instanceOfInboundPictureOrderInfoVo(value: object): value is InboundPictureOrderInfoVo {
    return true;
}

export function InboundPictureOrderInfoVoFromJSON(json: any): InboundPictureOrderInfoVo {
    return InboundPictureOrderInfoVoFromJSONTyped(json, false);
}

export function InboundPictureOrderInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InboundPictureOrderInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'zone': json['zone'] == null ? undefined : json['zone'],
        'location': json['location'] == null ? undefined : json['location'],
        'additionalService': json['additionalService'] == null ? undefined : json['additionalService'],
        'remark': json['remark'] == null ? undefined : json['remark'],
        'warehouseRemarkCn': json['warehouseRemarkCn'] == null ? undefined : json['warehouseRemarkCn'],
        'warehouseRemarkKr': json['warehouseRemarkKr'] == null ? undefined : json['warehouseRemarkKr'],
        'allParcelTrackingNumber': json['allParcelTrackingNumber'] == null ? undefined : json['allParcelTrackingNumber'],
        'receiverDeliveryRequirement': json['receiverDeliveryRequirement'] == null ? undefined : json['receiverDeliveryRequirement'],
        'markNos': json['markNos'] == null ? undefined : json['markNos'],
    };
}

export function InboundPictureOrderInfoVoToJSON(json: any): InboundPictureOrderInfoVo {
    return InboundPictureOrderInfoVoToJSONTyped(json, false);
}

export function InboundPictureOrderInfoVoToJSONTyped(value?: InboundPictureOrderInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderId': value['orderId'],
        'orderCode': value['orderCode'],
        'zone': value['zone'],
        'location': value['location'],
        'additionalService': value['additionalService'],
        'remark': value['remark'],
        'warehouseRemarkCn': value['warehouseRemarkCn'],
        'warehouseRemarkKr': value['warehouseRemarkKr'],
        'allParcelTrackingNumber': value['allParcelTrackingNumber'],
        'receiverDeliveryRequirement': value['receiverDeliveryRequirement'],
        'markNos': value['markNos'],
    };
}

